import { useState } from 'react';
import { cn } from '@/lib/utils';

interface JsonViewerProps {
  data: unknown;
  className?: string;
  initialExpanded?: boolean;
}

export function JsonViewer({ data, className, initialExpanded = true }: JsonViewerProps) {
  const [expanded, setExpanded] = useState(initialExpanded);
  const json = JSON.stringify(data, null, 2);

  return (
    <div className={cn('relative', className)}>
      <button
        type="button"
        onClick={() => setExpanded(!expanded)}
        className="absolute right-2 top-2 rounded bg-muted px-2 py-0.5 text-xs text-muted-foreground hover:bg-muted/80"
      >
        {expanded ? 'Collapse' : 'Expand'}
      </button>
      <pre
        className={cn(
          'overflow-auto rounded-lg border bg-muted/50 p-4 text-xs font-mono leading-relaxed',
          !expanded && 'max-h-24',
        )}
      >
        <code>{json}</code>
      </pre>
    </div>
  );
}
